export default __webpack_public_path__ + "static/media/unavailable1.369800c4.svg";